import { FeatureToggleModel } from '@/types';

export interface FeatureToggleState {
  data: FeatureToggleModel[];
  isLoading: boolean;
  isLoaded: boolean;
}

export const featureToggleStateActions = ['feature_toggle_load_start', 'feature_toggle_load_end'] as const;

export type FeatureToggleStateAction = (typeof featureToggleStateActions)[number];
